<template lang="pug">
el-form-item.c-uploader__multi
  el-upload(
    action='/api/v2/util/uploader',
    name='files',
    :show-file-list="false",
    :on-success='handleUploadSuccess',
    :before-upload='beforeUpload')
    el-button(size='small', type='primary' icon='el-icon-plus') 画像アップロード
    .el-upload__tip(slot="tip")
      p
        | jpg/png/gif 500kb以下 : 推奨サイズ {{ratioText['r' + ratio]}}
        br
        | ( 縦横比の異なる画像も登録可能ですが表示する際にデザインが崩れたり画像が見切れる場合などがあります )
  el-row(:gutter='20')
    el-col(v-for='(file, index) in getValue().images' :key='index' :span='12')
      template(v-if='ratio === "v"')
        img(:src='file.uri')
      template(v-else)
        .thumb__wrp(:class='[ratioClass]')
          .thumb(:style='{ backgroundImage: "url(" + file.uri + ")"}')
      .func
        i.icon.el-icon-delete(@click='deleteImage(index)')
  el-button(size='small', type='success' icon='el-icon-sort' @click='showModal') 順序変更
  modal-sort-element(:visible='modalvisible' @hideModal='hideModal' :list='getValue().images' type='image')
</template>

<script>
import ModalSortElement from '@/components/Element/Modal/SortElement'
export default {
  name: 'ElementUploadMulti',
  data () {
    return {
      modalvisible: false,
      ratioClass: 'c-uploader__' + this.ratio,
      ratioText: {
        r16_9: '16:9の画像',
        r1_1: 'w 960px * h 960px 以上の正方形',
        r2_1: 'w 960px * h 480px 以上',
        r350_197: 'w 1400px * h 788px 以上',
        r960_531: 'w 960px * h 531px 以上',
        r960_623: 'w 960px * h 623px 以上',
        r960_351: 'w 960px * h 351px 以上',
        r40_17: 'w 960px * h 408px 以上',
        rv: '高さは成り行きで表示されます左右の画像の縦サイズを合わせるようにしてください'
      }
    }
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    /**
     * 画角を判定
     * 1_1
     * 350_197
     * 960_623
     * 960_351
     * 40_17
     * v for Vertical image
     */
    ratio: {
      type: String,
      default: '2_1'
    },
    datakey: {
      type: String,
      required: true
    }
  },
  methods: {
    handleUploadSuccess (res, file) {
      let data = this.getValue()
      const value = {
        id: res.id,
        uri: res.uri
      }
      data.images.push(value)
    },
    /**
     * @param {Object} file
     * @returns {undefined}
     */
    beforeUpload (file) {
      const isLt500kb = file.size / 1024 / 1024 < 0.5
      if (!/^image\/[jpeg|png|gif|webp]/.test(file.type)) {
        this.$message.error('jpg/png/gifフォーマットの画像を登録してください')
        return false
      }
      if (!isLt500kb) {
        this.$message.error('500kb以下の画像ファイルを登録してください')
        return false
      }
      return true
    },
    /**
     * @param {Number} index
     */
    deleteImage (index) {
      let data = this.getValue()
      data.images.splice(index, 1)
    },
    /**
     * @param {String} key
     */
    showModal (key) {
      this.modalvisible = true
    },
    /**
     * @param {String} key
     * @param {Object} data
     */
    hideModal (key, data) {
      this.modalvisible = false
    },
    /**
     * @return {Object}
     */
    getValue () {
      let data = this.form
      this.datakey.split('.').forEach((v, i) => {
        data = data[v]
      })
      return data
    }
  },
  components: {
    ModalSortElement
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Upload/Multi/index.vue